import { render, staticRenderFns } from "./GalleryView.vue?vue&type=template&id=bd920416&scoped=true"
import script from "./GalleryView.vue?vue&type=script&lang=js"
export * from "./GalleryView.vue?vue&type=script&lang=js"
import style0 from "./GalleryView.vue?vue&type=style&index=0&id=bd920416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd920416",
  null
  
)

export default component.exports